/* SORTED. theme JS */
(function() {
  'use strict';

  // Scroll-based nav state
  const nav = document.getElementById('siteNav');
  if (nav) {
    const onScroll = () => {
      if (window.scrollY > 40) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Reveal on scroll (IntersectionObserver)
  const reveals = document.querySelectorAll('.reveal, .split-reveal');
  if (reveals.length) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(el => obs.observe(el));
  }

  // Wrap split-reveal text in spans (if not already done in template)
  document.querySelectorAll('.split-reveal').forEach(el => {
    if (el.querySelector('.word')) return; // already wrapped
    const text = el.innerHTML;
    el.innerHTML = text.split(' ').map(w => `<span class="word">${w}</span>`).join(' ');
  });

  // Accordion (used on product page, FAQ)
  window.toggleAcc = function(el) {
    el.classList.toggle('open');
  };

  // Subscription / one-time selector on product page
  window.selectSortedOption = function(opt) {
    const sub = document.getElementById('optSub');
    const one = document.getElementById('optOne');
    const savings = document.getElementById('savings');
    const priceDisplay = document.getElementById('ppAddPrice');
    const sellingPlanInput = document.getElementById('sellingPlanInput');

    if (!sub || !one) return;

    if (opt === 'sub') {
      sub.classList.add('selected');
      one.classList.remove('selected');
      if (savings) savings.style.display = 'flex';
      if (priceDisplay) priceDisplay.textContent = '— A$59';
      if (sellingPlanInput) sellingPlanInput.value = sellingPlanInput.dataset.subscriptionPlan || '';
    } else {
      one.classList.add('selected');
      sub.classList.remove('selected');
      if (savings) savings.style.display = 'none';
      if (priceDisplay) priceDisplay.textContent = '— A$90';
      if (sellingPlanInput) sellingPlanInput.value = '';
    }
  };

  // Product gallery thumbnails
  window.changeSortedImg = function(thumb) {
    const main = document.getElementById('ppMainImg');
    const pager = document.getElementById('ppPager');
    if (!main || !thumb) return;

    main.style.opacity = 0.4;
    setTimeout(() => {
      main.src = thumb.dataset.src;
      main.style.opacity = 1;
    }, 200);

    document.querySelectorAll('.pp-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');

    if (pager && thumb.dataset.idx) {
      const total = document.querySelectorAll('.pp-thumb').length;
      pager.textContent = String(thumb.dataset.idx).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
    }
  };

  // Toast notification
  window.showSortedToast = function(msg) {
    let toast = document.getElementById('sortedToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'sortedToast';
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    requestAnimationFrame(() => toast.classList.add('show'));
    setTimeout(() => toast.classList.remove('show'), 2800);
  };

  // Newsletter form
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const btn = form.querySelector('button');
      if (btn) btn.textContent = '✓ Subscribed';
      showSortedToast('Thanks — we\'ll be in touch.');
    });
  });

})();
